import { Component, OnInit } from '@angular/core';
import { Globals } from "../../_models/globals";
import { User } from "../../_models/user";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";
import { AlertService } from '../../_services/alert.service';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { ApiIntegration } from '../../_services/api.integration';

@Component({
  selector: 'app-admin-manage-wefast',
  templateUrl: './admin-manage-wefast.component.html',
  styleUrls: ['./admin-manage-wefast.component.scss'],
})
export class AdminManageWefastComponent implements OnInit {
  carrierNameError: string;
  tokenError: string;
  wefastList: any = {};
  carrierId: any;

  constructor(private api: ApiIntegration, private alertService: AlertService, private g: Globals, private user: User, private http: HttpClient, private router: Router, private route: ActivatedRoute) {
    this.carrierId = this.route.snapshot.paramMap.get('id');
    if (this.carrierId) {
      this.api.adminGetCarrierInfoById(this.carrierId, this.user.organizationId).subscribe((data: any) => {
        this.wefastList = data;
      }, err => {
        this.alertService.error('Error', err);
      });
    }
  }

  carrierNameBlur() {
    this.carrierNameError = "";
    if (!this.wefastList.connectionName) {
      this.carrierNameError = 'Please enter carrier name';
    }
  }

  tokenBlur() {
    this.tokenError = "";
    if (!this.wefastList.token) {
      this.tokenError = 'Please enter token';
    }
  }


  ngOnInit() { }

  verify() {

    this.g.loaderDisplay = "display";
    this.carrierNameError = "";
    this.tokenError = "";

    if (!this.wefastList.connectionName) {
      this.carrierNameError = 'Please enter carrier name';
    }
    if (!this.wefastList.token) {
      this.tokenError = 'Please enter token';
    }
    if (this.carrierNameError != "" || this.tokenError != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    // api body
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateCarrierCredentials', {
      "connectionName": this.wefastList.connectionName,
      "carrierCode": this.wefastList.carrierCode,
      "organizationId": this.wefastList.organizationId,
      "token": this.wefastList.token,
      "carrierId": this.wefastList.carrierId
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Wefast', 'Create Successfully');
          this.router.navigate(['/admin/adminCarriers']);
        }
        else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          console.log(err);
        })
  }

}
